
import React from "react";
import { useNavigate } from "react-router-dom";
import { Create, GetAllSeatplanOptions, GetAllfacilityOptions } from "adminApi/HallRoomTypeApi/HallRoomType";
import { validateForm } from "utils/validation";
import { HallTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddAddHallRoomTypeForm from "./Componates/AddHallRoomTypeForm";
import fields from "../json/HallRoomTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";


const AddHallRoomType = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    HallTypeRules
  );

  //Get Zones Types
  const {
    data: SeatplanOptions,
    loading: loadingSeatplanOptions
  } = useFetchAllData(
    GetAllSeatplanOptions
  );

  //Get Zones Types
  const {
    data: facilityOptions,
    loading: loadingfacilityOptions
  } = useFetchAllData(
    GetAllfacilityOptions
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();

      // remove preview-only field
      delete formValues.imagePreview;

      // convert array to JSON
      if (Array.isArray(formValues.facility_id)) {
        formData.append(
          "facility_id",
          JSON.stringify(formValues.facility_id)
        );
      }

      Object.entries(formValues).forEach(([key, val]) => {
        if (key === "facility_id") return;
        formData.append(key, val ?? "");
      });
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, HallTypeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Create Hall Room Type successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingSeatplanOptions || loadingfacilityOptions) && <Spinner isSpinner={true} />}
      <AddAddHallRoomTypeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Create Hall Seat Plan"
        handleFileChange={handleFileChange}
        formdata={formdata}
        SeatplanOptions={SeatplanOptions}
        setValues={setValues}
        facilityOptions={facilityOptions}
      />
    </>
  );
};

export default AddHallRoomType;
